import { BannerError } from '@/organisms';

import type { FunctionComponent } from 'react';
import type { TypeErrorProps } from './types';

/**
 * Error
 */
export const Error: FunctionComponent<TypeErrorProps> = ({
  className = '',
  statusCode,
}: TypeErrorProps) =>
  statusCode === 404 ? (
    <BannerError
      description="Puede que el enlace que has seguido no sea correcto o que la página haya sido eliminada"
      overlay={0.4}
      title="Lo sentimos, esta página no está disponible"
      backgroundImage="/assets/images/background-bannererror.jpg"
      className={className}
    />
  ) : (
    <BannerError
      description="Pero estamos trabajando en ello para resolverlo lo antes posible."
      overlay={0.4}
      title="¡Vaya! Parece que ha habido un problema"
      backgroundImage="/assets/images/background-bannererror.jpg"
      showReloadButton
      className={className}
    />
  );

Error.displayName = 'Error';
